<template>
  <div class="row">
    <div class="col-lg-3 col-xxxl-3">
      <div class="products-sidebar-filter bg-white letter-spacing mb-25">
        <div class="title">
          <h5 class="mb-0 fw-semibold text-secondary">Filtres</h5>
        </div>
        <!-- <div class="sidebar-item">
          <h6 class="text-black fw-bold mb-5">Auteur / producteur</h6>
          <form class="search-box position-relative mb-0">
            <input type="text" class="form-control shadow-none text-black rounded-0 border-0"
              placeholder="Rechercher un document par auteur" />
            <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
              <i class="flaticon-search-interface-symbol"></i>
            </button>
          </form>
        </div> -->
        <div class="sidebar-item">
          <h6 class="text-black fw-bold fs-md-15">Catégories</h6>
          <ul class="categories-list ps-0 mb-0 list-unstyled">
            <li class="d-flex align-items-center justify-content-between text-paragraph">
              <div class="form-check mb-0">
                <input class="form-check-input shadow-none" type="checkbox" id="allCategories" />
                <label class="form-check-label fs-md-15 fw-medium" for="allCategories">
                  Toutes les catégories
                </label>
              </div>
              <span class="d-block fw-medium text-muted">{{ totalCategoriesDocuments }}</span>
            </li>
            <li v-for="category in displayedCategories" :key="category.id"
              class="d-flex align-items-center justify-content-between text-paragraph">
              <div class="form-check mb-0">
                <input class="form-check-input shadow-none" type="checkbox" :id="`category_${category.id}`"
                  v-model="selectedCategoriesIds" :value="category.id" />
                <label class="form-check-label fs-md-15 fw-medium" :for="`category_${category.id}`">
                  {{ category.nom }}
                </label>
              </div>
              <span class="d-block fw-medium text-muted">{{ category.nombreDocuments }}</span>
            </li>
          </ul>
          <button type="button" v-if="hasMoreCategories" @click="toggleCategoriesDisplay"
            class="see-more-btn mt-15 bg-transparent p-0 border-0 position-relative text-uppercase text-primary fw-medium fs-13">
            {{ showAllCategories ? 'Voir moins' : 'Voir plus' }}
          </button>
        </div>
        <div class="sidebar-item">
          <h6 class="text-black fw-bold fs-md-15">Analyse(Tags)</h6>
          <div class="tags-container">
            <div>
              <input class="form-check-input shadow-none d-none" type="checkbox" id="allBrands" />
              <label class="form-check-label badge-checkbox fw-medium" for="allBrands">
                <span class="badge-text">Tous les tags</span>
                <span class="badge bg-secondary ms-2">{{ totalTagsDocuments }}</span>
              </label>
            </div>
            <div v-for="tag in displayedTags" :key="tag.id">
              <input class="form-check-input shadow-none d-none" type="checkbox" :id="`tag_${tag.id}`"
                v-model="selectedTagsIds" :value="tag.id" />
              <label class="form-check-label badge-checkbox fw-medium" :for="`tag_${tag.id}`">
                <span class="badge-text">{{ tag.nom }}</span>
                <span class="badge bg-secondary ms-2">{{ tag.nombreDocuments }}</span>
              </label>
            </div>
          </div>
          <button type="button" v-if="hasMoreTags" @click="toggleTagsDisplay"
            class="see-more-btn mt-15 bg-transparent p-0 border-0 position-relative text-uppercase text-primary fw-medium fs-13">
            {{ showAllTags ? 'Voir moins' : 'Voir plus' }}
          </button>
        </div>
      </div>
    </div>
    <div class="col-lg-9 col-xxxl-9">
      <div class="row">
        <div class="col-12 mb-25">
          <div
            class=" bg-white text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-5">
            <div class="row align-items-center">
              <div class="col-xl-6 col-lg-6 col-md-6">
                <Multiselect :appendToBody="true" v-model="auteurSelected" :options="auteurOptions"
                  placeholder="Sélectionner l'auteur" :searchable="true" label="label" track-by="label"
                  class="modern-multiselect" @change="value => auteurSelected = value" />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6">
                <Multiselect :appendToBody="true" v-model="genreSelected" :options="genreOptions" :searchable="true"
                  placeholder="Sélectionner le genre" label="label" track-by="label" class="modern-multiselect"
                  @change="value => genreSelected = value" />
              </div>
              <!-- <div class="col-xl-4 col-lg-5 col-md-6">
                <Multiselect :options="[]" :preserve-search="true"
                  :multiple="false" :searchable="true" placeholder="Rechercher par genre" label="label"
                  track-by="label" class="modern-multiselect"
                  @change="(value) => { }" />
              </div> -->
            </div>
          </div>
        </div>
        <div class="col-sm-4 col-lg-4 col-xxxl-3" v-for="document in documents" :key="document.id">
          <div class="card mb-25 border-0 rounded-0 bg-white single-product-box">
            <div class="card-body p-0 letter-spacing">
              <div class="image position-relative">
                <router-link to="/product-details" class="d-block">
                  <img src="../../../assets/images/products/default1.jpg" :alt="document?.titre || 'Document'" />
                </router-link>
                <!-- Overlay avec icônes télécharger et visionner -->
                <div class="overlay position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
                  style="top: 0; left: 0; background: rgba(0, 0, 0, 0.5); opacity: 0; transition: opacity 0.3s;">
                  <div class="overlay-actions d-flex gap-3">
                    <button v-if="document?.estPublique && document?.estTelechargeable"
                      class="btn btn-light rounded-circle p-2" type="button" title="Télécharger"
                      @click="downloadDocument(document)">
                      <i class="flaticon-download"></i>
                    </button>
                    <button v-if="document?.estPublique" class="btn btn-light rounded-circle p-2" type="button"
                      title="Visionner" @click="openPdfViewer(document)">
                      <i class="flaticon-eye"></i>
                    </button>
                    <button class="btn btn-light rounded-circle p-2" type="button" title="Ajouter aux favoris"
                      @click="toggleFavorite(document)">
                      <i class="flaticon-heart"></i>
                    </button>
                  </div>
                </div>

                <!-- Ribbon en bas à droite -->
                <div class="ribbon position-absolute">
                  <span class="ribbon-text">{{ document.categorie?.nom || 'Catégorie' }}</span>
                </div>
                <!-- <div class="ribbon position-absolute" v-else-if="document.statut === 'populaire'">
                  <span class="ribbon-text bg-success">Populaire</span>
                </div> -->
              </div>
              <div class="content p-20">
                <h4 class="mb-5 fw-semibold fs-16 fs-lg-18" style="height: 60px;">
                  <a href="#" class="text-decoration-none text-black">
                    {{ truncateText(document?.titre, 35) || 'Titre non disponible' }}
                  </a>
                </h4>
                <div>
                  <p class="text-muted fw-medium fs-13 mb-0">
                    Auteur / Producteur:
                  </p>
                  <p class="text-black fw-bold fs-6 mb-0">
                    {{ document?.auteur?.nom || 'Auteur non renseigné' }} {{ document?.auteur?.prenoms || '' }}
                  </p>
                </div>
                <div class=" mb-2" v-if="document.anneePublication">
                  <small class="text-muted">
                    <i class="flaticon-calendar me-1"></i>
                    Publié en {{ document.anneePublication }}
                  </small>
                </div>
                <!-- Bouton conditionnel basé sur estPublique et estTelechargeable -->
                <button type="button" v-if="document?.estPublique"
                  class="add-to-cart-btn text-center d-block mt-15 fw-medium transition w-100 rounded-1 position-relative"
                  @click="openPdfViewer(document)">
                  Lire le document
                  <i class="flaticon-eye transition"></i>
                </button>
                <button type="button" v-else
                  class="add-to-cart-btn text-center d-block mt-15 fw-medium transition w-100 rounded-1 position-relative"
                  @click="openLoanModal(document)">
                  Demander un prêt
                  <i class="flaticon-shopping-cart-2 transition"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Message si aucun document -->
        <div class="col-12" v-if="documents?.length === 0">
          <div class="text-center py-5">
            <i class="flaticon-book fs-1 text-muted"></i>
            <h5 class="text-muted mt-3">Aucun document trouvé</h5>
            <p class="text-muted">Aucun document ne correspond à vos critères de recherche.</p>
          </div>
        </div>
      </div>

      <div class="modal fade createNewModal" id="DemandePretModal" tabindex="-1" ref="demandePretModalRef"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content p-15 p-md-40">
            <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
              <h5 class="modal-title fw-bold text-black"> Demande de prêt</h5>
            </div>
            <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
              <div class="document-info mb-4 p-3 bg-light rounded">
                <h6 class="fw-bold mb-2">{{ selectedDocument?.titre }}</h6>
                <p class="text-muted mb-1">
                  <i class="flaticon-user me-1"></i>
                  Auteur: {{ selectedDocument?.auteur?.nom || 'Auteur non renseigné' }} {{
                    selectedDocument?.auteur?.prenoms || '' }}
                </p>
                <p class="text-muted mb-1">
                  <i class="flaticon-more-1 me-1"></i>
                  Catégorie: {{ selectedDocument?.categorie?.description || 'Non spécifiée' }}
                </p>
              </div>
              <Form ref="elementForm" @submit="submitLoanRequest" :validation-schema="loanSchema">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Date de début<span class="text-danger">*</span>
                      </label>
                      <Field name="dateDebut" type="date" class="form-control shadow-none fs-md-15 text-black"
                        placeholder="Entrer la date de début" :min="today" />
                      <ErrorMessage name="dateDebut" class="text-danger" />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Date de fin <span class="text-danger">*</span>
                      </label>
                      <Field name="dateFin" type="date" class="form-control shadow-none fs-md-15 text-black"
                        placeholder="Entrer la date de fin" />
                      <ErrorMessage name="dateFin" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Motif de la demande <span class="text-danger">*</span>
                      </label>
                      <Field name="motif" v-slot="{ field }">
                        <textarea class="form-control" id="motif" rows="3" v-model="field.value" v-bind="field"
                          placeholder="Décrivez le motif de votre demande de prêt (minimum 10 caractères)..."></textarea>
                      </Field>
                      <ErrorMessage name="motif" class="text-danger" />
                      <div class="form-text">
                        <small class="text-muted">
                          Caractères saisis: <Field name="motif" v-slot="{ field }">{{ field.value ? field.value.length
                            : 0 }}</Field>/500
                        </small>
                      </div>
                    </div>
                  </div>

                  <!-- Info sur la durée du prêt -->
                  <div class="col-md-12">
                    <div class="alert alert-info" role="alert">
                      <i class="flaticon-info me-2"></i>
                      <small>
                        <strong>Informations importantes :</strong><br>
                        • Vous recevrez une notification de confirmation par email<br>
                        • Le document devra être retourné dans les délais impartis
                      </small>
                    </div>
                  </div>
                </div>
                <div class="float-end">
                  <button
                    class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                    type="submit">
                    Enregistrer

                  </button>
                  <button type="button" class="btn btn-danger ms-5" data-bs-dismiss="modal" aria-label="Close">Annuler
                  </button>
                </div>
              </Form>
            </div>
            <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
        </div>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import { hideModal, showModal, success } from "@/utils/utils";
import { Document } from "@/models/Document";
import ApiService from "@/services/ApiService";
import { format_date, suppression, error } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import { useRouter } from 'vue-router';
import { hide } from "@popperjs/core";
import Multiselect from '@vueform/multiselect/src/Multiselect';
// Reactive state
const documents = ref<Array<Document>>([]);
const document = ref<Document>();
const categories = ref<Array<any>>([]); // Assuming categories are of type any, adjust as necessary
const tags = ref<Array<any>>([]); // Assuming tags are of type any, adjust as necessary
const showAllTags = ref(false); // État pour contrôler l'affichage de tous les tags
const showAllCategories = ref(false); // État pour contrôler l'affichage de toutes les catégories
const baseUrl = ref(ApiService.vueInstance.axios.defaults.baseURL?.split("api")[0]);

// Pagination
const searchTerm = ref('');
const page = ref(1);
const totalPages = ref(0);
const limit = ref(10);
const totalElements = ref(0);
const router = useRouter();
const auteurOptions = ref<{ value: any; label: any }[]>([]);
const genreOptions = ref([]);
const auteurSelected = ref(null);
const genreSelected = ref(null);
// Filtres sélectionnés pour catégories et tags
const selectedCategoriesIds = ref<Array<number>>([]);
const selectedTagsIds = ref<Array<number>>([]);
function truncateText(text: string, maxLength: number): string {
  if (!text) return ''
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
}

// Loan request modal
const selectedDocument = ref<Document | null>(null);

// Today's date for date validation
const today = computed(() => {
  const date = new Date();
  return date.toISOString().split('T')[0];
});

// Computed pour gérer l'affichage des tags
const displayedTags = computed(() => {
  if (showAllTags.value) {
    return tags.value;
  }
  return tags.value.slice(0, 15);
});

// Computed pour gérer l'affichage des catégories
const displayedCategories = computed(() => {
  if (showAllCategories.value) {
    return categories.value;
  }
  return categories.value.slice(0, 15);
});

const hasMoreTags = computed(() => {
  return tags.value.length > 15;
});

const hasMoreCategories = computed(() => {
  return categories.value.length > 15;
});

// Computed pour calculer le nombre total de documents pour tous les tags
const totalTagsDocuments = computed(() => {
  return tags.value.reduce((total, tag) => total + (tag.nombreDocuments || 0), 0);
});

// Computed pour calculer le nombre total de documents pour toutes les catégories
const totalCategoriesDocuments = computed(() => {
  return categories.value.reduce((total, category) => total + (category.nombreDocuments || 0), 0);
});

const demandePretModalRef = ref<null | HTMLElement>(null);
// Validation schema for loan request form
const loanSchema = yup.object({
  dateDebut: yup
    .string()
    .required('La date de début est obligatoire')
    .test('is-today-or-future', 'La date de début ne peut pas être antérieure à aujourd\'hui', function (value) {
      if (!value) return false;
      const startDate = new Date(value);
      const todayDate = new Date();
      todayDate.setHours(0, 0, 0, 0);
      return startDate >= todayDate;
    }),
  dateFin: yup
    .string()
    .required('La date de fin est obligatoire')
    .test('is-after-start', 'La date de fin doit être postérieure à la date de début', function (value) {
      const { dateDebut } = this.parent;
      if (!value || !dateDebut) return false;
      const startDate = new Date(dateDebut);
      const endDate = new Date(value);
      return endDate > startDate;
    })
    .test('max-30-days', 'La durée maximale d\'un prêt est de 30 jours', function (value) {
      const { dateDebut } = this.parent;
      if (!value || !dateDebut) return false;
      const startDate = new Date(dateDebut);
      const endDate = new Date(value);
      const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays <= 30;
    }),
  motif: yup
    .string()
    .required('Le motif est obligatoire')
    .min(10, 'Le motif doit contenir au moins 10 caractères')
    .max(500, 'Le motif ne peut pas dépasser 500 caractères')
});

// Helper functions
const calculateLoanDuration = (startDate: string, endDate: string): number => {
  if (!startDate || !endDate) return 0;
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffTime = Math.abs(end.getTime() - start.getTime());
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

const formatDate = (dateString: string): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR');
};

const rechercher = () => {
  getAllDocuments(page.value, limit.value, searchTerm.value, auteurSelected.value, selectedCategoriesIds.value, selectedTagsIds.value, genreSelected.value);
};

// Fonction pour basculer l'affichage de tous les tags
const toggleTagsDisplay = () => {
  showAllTags.value = !showAllTags.value;
};

// Fonction pour basculer l'affichage de toutes les catégories
const toggleCategoriesDisplay = () => {
  showAllCategories.value = !showAllCategories.value;
};

// Fonction pour gérer la pagination
const handlePaginate = (data) => {
  page.value = data.page_;
  limit.value = data.limit_;
  getAllDocuments(page.value, limit.value, searchTerm.value, auteurSelected.value, selectedCategoriesIds.value, selectedTagsIds.value, genreSelected.value);
};


const getAllDocuments = (page = 1, limi = 10, searchTerm = '', auteurSelected, categorieSelected, tagSelected, genreSelected) => {
  return ApiService.get(`/recherche/documents?page=${page}&limit=${limi}&mot=${searchTerm}&auteur=${auteurSelected || ''}&categories=${categorieSelected || ''}&tags=${tagSelected || ''}&genre=${genreSelected || ''}&`)
    .then(({ data }) => {
      console.log('valeurs', data);
      documents.value = data.data.data;
      totalPages.value = data.data.totalPages;
      limit.value = data.data.limit;
      totalElements.value = data.data.totalElements;
      return data.data;
    })
    .catch(({ response }) => {
      error(response.data.message)
    });
};

const getAllCategories = (page = 1, limi = 10, searchTerm = '') => {
  return ApiService.get(`/categories/with-count`)
    .then(({ data }) => {
      console.log('valeurs', data);
      categories.value = data.data;
      return data.data;
    })
    .catch(({ response }) => {
      error(response.data.message)
    });
};

const getAllTags = (page = 1, limi = 10, searchTerm = '') => {
  return ApiService.get(`/tags/with-count`)
    .then(({ data }) => {
      console.log('valeurs', data);
      tags.value = data.data;
      return data.data;
    })
    .catch(({ response }) => {
      error(response.data.message)
    });
};

const moddifier = (EditDocument) => {
  document.value = EditDocument;
};

const openPdfViewer = (document: Document) => {
  console.log('Document sélectionné:', baseUrl.value, document);
  let pdfUrl = `${baseUrl.value}uploads/2025080113391339130buLZ33wKT.pdf`;

  if (document.nomFichier) {
    pdfUrl = `${baseUrl.value}uploads/${document.nomFichier}`;
  }


  console.log('URL PDF utilisée:', pdfUrl);

  // Enregistrer l'historique de lecture
  const historiqueData = {
    document: document.id,
    types: 'LECTURE',
    user: JwtService.getUser()
  };

  ApiService.post('/historiques', historiqueData)
    .then(response => {
      console.log('Historique de lecture enregistré:', response.data);
    })
    .catch(error => {
      console.log('Erreur lors de l\'enregistrement de l\'historique de lecture:', error);
    });

  router.push({
    name: 'pdf-viewer',
    params: { id: document.id ?? 1 },
    query: { pdfUrl: pdfUrl }
  });
};

const downloadDocument = (document: Document) => {
  if (!document.estTelechargeable) {
    error("Ce document n'est pas téléchargeable");
    return;
  }

  console.log('Téléchargement du document:', document);

  // Enregistrer l'historique de téléchargement
  const historiqueData = {
    document: document.id,
    types: 'TELECHARGEMENT',
    user: JwtService.getUser()
  };

  ApiService.post('/historiques', historiqueData)
    .then(response => {
      console.log('Historique de téléchargement enregistré:', response.data);
    })
    .catch(error => {
      console.log('Erreur lors de l\'enregistrement de l\'historique de téléchargement:', error);
    });

  if (document.nomFichier) {
    const downloadUrl = `${baseUrl.value}uploads/${document.nomFichier}`;
    // Ouvrir le document dans un nouvel onglet
    window.open(downloadUrl, '_blank');
  }
};

const viewDocument = (document: Document) => {
  if (!document.estPublique) {
    error("Ce document n'est pas consultable");
    return;
  }

  // L'historique sera enregistré dans openPdfViewer
  openPdfViewer(document);
};

const toggleFavorite = (document: Document) => {
  console.log('Toggle favorite pour:', document);
  // Implement favorite toggle logic here
};

const openLoanModal = async (doc: Document) => {
  // Récupérer les informations du document sélectionné
  selectedDocument.value = doc;
  showModal(demandePretModalRef.value);
};

const submitLoanRequest = (values: any) => {
  console.log('Demande de prêt soumise:', values);
  console.log('Document sélectionné:', selectedDocument.value);

  // Here you would typically send the loan request to your backend
  const loanData = {
    document: selectedDocument.value?.id,
    documentTitre: selectedDocument.value?.titre,
    dateDebut: values.dateDebut,
    dateFin: values.dateFin,
    motif: values.motif,
    user: JwtService.getUser()
  };

  ApiService.post('/emprunts', loanData)
    .then(response => {
      console.log('Réponse de la demande de prêt:', response.data);
      success(response.data.message);
      // Close the modal
      hideModal(demandePretModalRef.value)
      // Reset the form or perform any other necessary actions
      selectedDocument.value = null;
    })
    .catch(error => {
      console.log('Erreur lors de la demande de prêt:', error);
      // error('Une erreur est survenue lors de la soumission de votre demande de prêt.');
    });

  // TODO: Call your loan request API
  // console.log('Données du prêt à envoyer:', loanData);
  // Show success message
  // alert('Votre demande de prêt a été soumise avec succès!');
};
const fetchSepcificEntity = async (optionName: any, url: string, param: string[]) => {
  try {
    const response = await ApiService.get(url);
    const data = response.data.data.data;
    optionName.value = data.map((item: any) => ({
      value: param[0] ? item[param[0]] : item.id,
      label: param[1] ? item[param[1]] : item.nom,
    }));
  } catch (error) {
    console.error("Erreur récupération données:", error);
  }
};
// Lifecycle
onMounted(async () => {
  console.log('Composant ProductsGrid monté');
  baseUrl.value = ApiService.vueInstance.axios.defaults.baseURL?.split("api")[0];
  await getAllDocuments(page.value, limit.value, searchTerm.value, auteurSelected.value, selectedCategoriesIds.value, selectedTagsIds.value, genreSelected.value);
  await getAllCategories();
  await fetchSepcificEntity(auteurOptions, '/all/auteurs', ['id', 'nom']);
  await fetchSepcificEntity(genreOptions, '/all/genres', ['id', 'nom']);
  await getAllTags();
});

// Watchers pour actualiser la liste des documents à chaque changement de filtre
watch([selectedCategoriesIds, selectedTagsIds, auteurSelected, genreSelected], () => {
  getAllDocuments(page.value, limit.value, searchTerm.value, auteurSelected.value, selectedCategoriesIds.value, selectedTagsIds.value, genreSelected.value);
});
</script>


<style scoped>
.image:hover .overlay {
  opacity: 1 !important;
}

.overlay-actions .btn {
  background-color: rgba(255, 255, 255, 0.9) !important;
  border: none !important;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.overlay-actions .btn:hover {
  background-color: white !important;
  transform: scale(1.1);
}

.overlay-actions .btn i {
  font-size: 16px;
  color: #333;
}

/* Ribbon styles */
.ribbon {
  bottom: 15px;
  right: 0;
  z-index: 10;
}

.ribbon-text {
  background: linear-gradient(135deg, #ff6b35, #f7931e);
  color: white;
  padding: 5px 12px 5px 18px;
  font-size: 11px;
  font-weight: bold;
  text-transform: uppercase;
  position: relative;
  display: inline-block;
  border-radius: 3px 0 0 3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.ribbon-text::before {
  content: '';
  position: absolute;
  left: -8px;
  top: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 0 25px 8px;
  border-color: transparent transparent #d35400 transparent;
}

.ribbon-text::after {
  content: '';
  position: absolute;
  right: -8px;
  top: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 25px 8px 0 0;
  border-color: #f7931e transparent transparent transparent;
}

/* Modal styles */
/* .modal-content {
  border: none;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.modal-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 15px 15px 0 0;
  padding: 20px 25px;
} */

/* .modal-header .btn-close {
  filter: invert(1);
  opacity: 0.8;
} */

/* .modal-header .btn-close:hover {
  opacity: 1;
}

.modal-body {
  padding: 25px;
} */

.document-info {
  border-left: 4px solid #667eea;
}

.form-label {
  color: #495057;
  margin-bottom: 8px;
}

.form-control,
.form-select {
  border: 1px solid #e0e6ed;
  border-radius: 8px;
  padding: 10px 15px;
  transition: all 0.3s ease;
}

.form-control:focus,
.form-select:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
}

/* .loan-duration-info {
  border-left: 3px solid #17a2b8;
} */

.modal-footer {
  padding: 20px 25px;
  border-radius: 0 0 15px 15px;
}

.btn {
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #5a67d8 0%, #6b3fa0 100%);
  transform: translateY(-1px);
}

.btn-secondary {
  background-color: #6c757d;
  border: none;
}

.btn-secondary:hover {
  background-color: #5a6268;
  transform: translateY(-1px);
}

/* Styles pour les documents */
.document-meta {
  font-size: 0.875rem;
}

.document-availability {
  margin-bottom: 10px;
}

.btn-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-disabled:hover {
  transform: none !important;
}

.single-product-box:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
  transition: all 0.3s ease;
}

.text-danger {
  color: #dc3545 !important;
}

/* Styles pour les badges de checkboxes des tags */
.tags-container {
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.badge-checkbox {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border: 2px solid #e9ecef;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 13px;
  color: #495057;
  text-decoration: none !important;
  white-space: nowrap;
}

.badge-checkbox:hover {
  background-color: #e9ecef;
  border-color: #dee2e6;
  transform: translateY(-1px);
}

.form-check-input:checked+.badge-checkbox {
  background-color: #ffbe00;
  border-color: #ffbe00;
  color: white;
}

.form-check-input:checked+.badge-checkbox .badge {
  background-color: rgba(255, 255, 255, 0.3) !important;
  color: white !important;
}

.badge-checkbox .badge-text {
  margin-right: 4px;
}

.badge-checkbox .badge {
  font-size: 11px;
  padding: 2px 6px;
}
</style>
